<template>
  <modal
  name="set-conference-pin-modal"
  height="auto"
  :pivot-y="0.3"
  :adaptive="true"
  :width="428"
  @before-open="beforeOpen">
    <div class="SetConferencePin__container">
      <div class="SetConferencePin__title">
        Change Conference PIN
      </div>
      <div class="SetConferencePin__description">
        Enter your new PIN below.
      </div>
      <form name="settings">
        <div class="Grid-row">
          <div class="form-label uppercase">
            Your PIN
          </div>
          <input
          v-focus
          type="text"
          name="pin"
          placeholder="Enter PIN of Conference Call"
          v-model="pin"
          class="field"
          :class="{'is-danger': errors.has('pin')}"
          v-validate="'required|min:4|max:10|numeric'"
          data-vv-delay="500"
          data-vv-as="PIN"
          data-vv-name="pin"
          required>
          <span v-show="errors.has('pin')"
                class="form-help is-danger">
            {{ errors.first('pin') }}
          </span>
        </div>
        <div class="Grid-row">
          <div class="form-actions pull-right">
            <a @click="cancel"
               class="cancel-btn">cancel</a>
            <a @click="submit"
               class="submit-btn">save</a>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'SetPin',
    data() {
      return {
        pin: null
      };
    },
    methods: {
      submit() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$store.dispatch('setConferencePin', this.pin);
            this.$modal.hide('set-conference-pin-modal');
          }
        });
      },
      cancel() {
        this.$modal.hide('set-conference-pin-modal');
      },
      beforeOpen(event) {
        this.pin = event.params.pin;
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// set-conference-pin.modal.vue?3c75a2fb